import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { dashApi } from "./api";

const AuthContext = createContext(null);

export const DashboardAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await dashApi.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await dashApi.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await dashApi.post("/auth/logout"); }
    catch (e) {
      // Ignore network failure — we still clear local state so the UI
      // recovers even if the user is offline / server unreachable.
      if (typeof console !== "undefined") console.debug("logout network error:", e?.message);
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useDashAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useDashAuth must be used inside <DashboardAuthProvider>");
  return ctx;
};
